import { render } from "./DiscussionQuestions.vue?vue&type=template&id=3e7baad0"
import script from "./DiscussionQuestions.vue?vue&type=script&lang=js"
export * from "./DiscussionQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nogglema/Documents/Ecampus/css-205-lab-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__